import 'css-chunksrc/client/pages/planzoneParametersPage/organization/viewToggle/styles.scss';export default {
  "viewToggle": "_viewToggle_i60a8_1",
  "iconBox": "_iconBox_i60a8_10",
  "icon": "_icon_i60a8_10",
  "text": "_text_i60a8_21",
  "read": "_read_i60a8_34"
};